import React from "react";
import { Outlet } from "react-router-dom";
import '../assets/css/newStyle.css';
const NewStyleComponent = () => {
    return (
        <Outlet />
    )
}
export default NewStyleComponent;